// Kênh dịch vụ chat KH (soi gương 3dfreezy): mỗi khách tối đa 3 luồng RIÊNG.
export const SVC_LABEL = { kd: 'Kinh doanh', cskh: 'CSKH', dvkh: 'Phòng mua' };
export const SVC_SHORT = { kd: 'KD', cskh: 'CSKH', dvkh: 'Mua' };
export const SVC_ORDER = ['kd', 'cskh', 'dvkh'];

// Khoá gộp các kênh của CÙNG một khách: ưu tiên id KH SocSon, rồi mã KH.
export const custKey = (c) => String(c.socsonUserId || c.custCode || c.id || '');

// Gom danh sách hội thoại KH theo KHÁCH: mỗi nhóm = 1 khách + các kênh của họ.
// Trả mảng nhóm đã sắp: ghim trước, rồi theo tin mới nhất.
export function groupByCustomer(convs) {
  const map = new Map();
  for (const c of convs) {
    const k = custKey(c);
    let g = map.get(k);
    if (!g) { g = { key: k, name: c.name, custCode: c.custCode, custSaleName: c.custSaleName, custSaleUser: c.custSaleUser, chans: {}, list: [] }; map.set(k, g); }
    g.chans[c.svcType || 'kd'] = c;
    g.list.push(c);
    if (c.custSaleName) g.custSaleName = c.custSaleName;
    if (c.custSaleUser) g.custSaleUser = c.custSaleUser; // id sale (so "KH của mình" -> ẩn tên sale)
  }
  const groups = [...map.values()].map((g) => {
    const unread = g.list.reduce((a, c) => a + (c.unread || 0), 0);
    const pinned = g.list.some((c) => c.pinned);
    // Kênh đại diện để mở đầu tiên: kênh có tin chưa đọc mới nhất, không thì tin mới nhất.
    const rep = [...g.list].sort((a, b) =>
      (b.unread || 0) - (a.unread || 0) ||
      new Date(b.lastMessage?.at || 0) - new Date(a.lastMessage?.at || 0))[0];
    const starred = g.list.some((c) => c.starred); // KH doanh thu cao (backend chấm theo ngưỡng) -> gắn sao
    return { ...g, unread, pinned, starred, rep, lastMessage: rep?.lastMessage, updatedAt: rep?.updatedAt };
  });
  return groups.sort((a, b) =>
    (a.pinned === b.pinned ? 0 : a.pinned ? -1 : 1) ||
    new Date(b.lastMessage?.at || 0) - new Date(a.lastMessage?.at || 0));
}

// Các kênh của cùng khách (để hiện tab trong cửa sổ) — theo thứ tự kd/cskh/dvkh.
export function channelsOfSameCustomer(conv, allConvs) {
  const k = custKey(conv);
  const found = allConvs.filter((c) => custKey(c) === k);
  return SVC_ORDER.map((t) => found.find((c) => (c.svcType || 'kd') === t)).filter(Boolean);
}
